export default "__VITE_ASSET__0257e182__"